<template>
<div class="custom d-inline">
    <bee-label class="custom d-inline"
		:color="type && withColor ? perspective ?( type == 'debit' ? 'green' : 'red') : ( type == 'debit' ? 'red' : 'green') : 'black'"
		:bold="true" :content="value" :empty-state="emptyState"
    >
    </bee-label>
</div>
</template>
<script>
import currency from "currency.js";
import ls from '../../../settings/localStorageExtension'
export default {
name: "BeeMoneyLabel",
data: () => ({
    model: null
}),
props: ["symbol", "number", "type", "withColor", "emptyState", "perspective"],
computed: {
    value() {
    if(this.symbol)
		return this.number != 0 && this.number ? currency(this.number, { separator: ",", decimal: ".", symbol:ls.getVisibleSymbolMoney()?this.symbol:""}).format() : null;
		return this.number != 0 && this.number ? currency(this.number, { separator: ",", decimal: ".", symbol: ""}).format()  : null;
		// console.log(currency(temp).value); /* backward converter*/
    },
},
mounted() {
	this.model = this.number
}
};
</script>
<style>
.custom {
    caret-color: auto !important;
    font-family: Calibri !important;
    font-weight: 550 !important;
    font-size: 1.05rem !important;
}
</style>
